import { GROUPS, PREFIX } from '@/service/apiConf';
import { get } from '@/service/request';
import { getPathnameForContextParsing } from '@/utils/pathContext';

export const loginUrlMap = {
  getGpuTypes: () => `${PREFIX.vapis(GROUPS.clusterinfo)}/gpuoptions`,
};

export function getGpuTypes(params?: any) {
  return get(`${loginUrlMap.getGpuTypes()}`, params, { flag: true });
}

export function getUrlWorkspace() {
  const [, var0, name1] = getPathnameForContextParsing().split('/');
  const obj = {
    [var0]: name1,
  };
  return obj.console || obj.wsp || obj.ws;
}

export function getWorkspacePrefix(pre = 'v1alpha1') {
  let res = pre;
  const workspace = getUrlWorkspace();
  const arr = getPathnameForContextParsing().split('/');
  if (workspace) {
    res = `${pre}/workspaces/${arr[2]}`;
  }
  return res;
}

export const getClusterPrefix = () => {
  const [, var0, name1, var1, name2, var2, name3] = getPathnameForContextParsing().split('/');
  const obj = {
    [var0]: name1,
    [var1]: name2,
    [var2]: name3,
    [name1]: var1, // 数据中心分享
  };
  obj.cluster = obj.cluster || obj['data-center'];
  const prefix = obj.subcluster ? `clusters/${obj.cluster}/subclusters/${obj.subcluster}` : obj.cluster ? `dc/${obj.cluster}` : '';
  const currCluster = obj.subcluster || obj.cluster || obj.dc;
  return {
    prefix,
    cluster: currCluster,
    dataCenter: obj.cluster || obj.dc,
    subCluster: obj.subcluster,
  };
};

export const getCurrCluster = () => getClusterPrefix()?.cluster;
export const getCurrClusterPrefix = () => getClusterPrefix()?.prefix;
export const getCurrDataCenter = () => getClusterPrefix()?.dataCenter;
export const getCurrSubcluster = () => getClusterPrefix()?.subCluster;
